import SkeletonComponent from '@atoms/SkeletonComponent';
import React from 'react';

const ShimmerReferralInput: React.FC = () => <SkeletonComponent />;

export default ShimmerReferralInput;
